import './operatortools.scss';
import { JSX, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Button, ButtonGroup, Modal, OverlayTrigger, InputGroup, Spinner, Table, Tooltip, Form } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useToast } from '../../services/ToastContext';
import { TableWidget } from '../../components/table-widget/TableWidget';
import { ApexOptions } from 'apexcharts';
import ReactApexChart from 'react-apexcharts';
import Pagination from 'rc-pagination';
import Switch from 'react-switch';
import ConfirmationModal from '../../components/pop-up/PopUpAlert';
import { Bot, Link2, LucideIcon, Network, Play, Radar, Square, Users, Wrench } from 'lucide-react';
import '../../design-system/index.css';
import { chartTokens } from '../../design-system/chartTokens';
import { useTranslation } from 'react-i18next';
import { getLanguage } from '../../util/languages';

type Props = {
  darkmode: any;
};

export const OperatorTools = (Props:Props) => {
  interface CveData {
    cve_id: string;
    description: string;
    cvssVersion: string;
    score: number;
    source: string;
  }
  interface OperatorProfile {
    operatorId: string;
    operatorName: string;
    FortressURL: string;
    OperatorEmail: string;
    MasterOperator: boolean;
  }
  interface AccountProfile {
    id: string;
    email: string;
  }

  interface UrlData {
    'Age Profile': string;
    Status: 'Blocked' | 'Allowed';
  }

  interface PieChartData {
    series: number[];
    options: {
      labels: string[];
      // Add any other options specific to your pie chart library
    };
  }

  type AccountData = [
    {
      ID: number;
      'CPE ID': number;
      Registrant: string;
      'Date Registered': string;
      'Date Verified': string;
      'Firmware Version': string;
      'Serial Number': string;
      'Last Boot Time': string;
      'Risk Score': string;
      MAC_Address: string;
    }
  ];

  type portList = {
    CPE_ID: string;
    Serial_Number: string;
    MAC_Address: string;
    Port: string;
    Date_Registered: string;
  }[];
  // type RouterID = {
  //   'CPE ID': number;
  // };

  const [urlSearch, setUrlSearch] = useState<boolean>(false);
  const [url, setUrl] = useState<string>('');

  const [ipSearch, setIpSearch] = useState<boolean>(false);
  const [ip, setIp] = useState<string>();

  const [portSearch, setPortSearch] = useState<boolean>(false);
  const [routerId, setRouterId] = useState<string>('');

  const [isClicked, setIsClicked] = useState(false);
  const [cveData, setCveData] = useState<CveData | null>(null);
  const [scanData, setScanData] = useState<any>([]);
  const [switchStates, setSwitchStates] = useState<{ [key: string]: boolean }>({});
  const [allScanData, setAllScanData] = useState<any>([]);
  const [jobData, setJobData] = useState<any>([]);
  const [errorMessage, setErrorMessage] = useState<any>();
  const [accountData, setAccountData] = useState<AccountData>();
  const [selectedMenu, setSelectedMenu] = useState('Port Scanning');
  const [previousSelectedIDs, setPreviousSelectedIDs] = useState<portList>([]);
  const { operatorId } = useParams();
  const { showToastMessage } = useToast();
  const { t, i18n } = useTranslation();
  const inputRef = useRef(null);
  const [isChecked, setIsChecked] = useState<boolean>(true);
  const [portId, setPortId] = useState<Number>();
  const [portClicked, setPortClicked] = useState<boolean>(false);
  const [enableAgent, setEnableAgent] = useState<boolean>(false);
  const [operatorClicked, setOperatorClicked] = useState<boolean>(false);
  const [newOpClicked, setnewOpClicked] = useState<boolean>(false);
  const [editOpClicked, setEditOpClicked] = useState<boolean>(false);
  const [newAccountClicked, setNewAccountClicked] = useState<boolean>(false);
  const [editAccountClicked, setEditAccountClicked] = useState<boolean>(false);
  const [operatorData, setOperatorData] = useState<any>([]);
  // Add this state near your other state declarations
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [currentOperatorId, setCurrentOperatorId] = useState<string | null>(null);
  const [currentOperatorName, setCurrentOperatorName] = useState<string>('');
  const [currentOperatorStatus, setCurrentOperatorStatus] = useState<boolean>(false);

  const [userEmail, setUserEmail] = useState<string | null>(null);
  const [subOperatorsData, setSubOperatorsData] = useState<any[]>([]);
  const [subOperatorsDisabledMap, setSubOperatorsDisabledMap] = useState<{ [key: string]: boolean }>({});
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentPageOp, setCurrentPageOp] = useState<number>(1);
  const [filteredData, setFilteredData] = useState<any>([]);
  const [filteredOperatorData, setFilteredOperatorData] = useState<any>([]);
  const pageSize = 5;

  const [operatorAccountData, setOperatorAccountData] = useState<any>([]);
  const menuList = ['Port Scanning', 'Url', 'Operators', 'Agent'];

  // const menuList = ['Port Scanning', 'Url', 'IP Address'];
  const [operatorProfile, setOperatorProfile] = useState<OperatorProfile>({
    operatorId: '',
    operatorName: '',
    FortressURL: '',
    OperatorEmail: '',
    MasterOperator: false,
  });
  const [accountProfile, setAccountProfile] = useState<AccountProfile>({
    id: '',
    email: '',
  });
  const [newOperatorProfile, setNewOperatorProfile] = useState<OperatorProfile>({
    operatorId: '',
    operatorName: '',
    FortressURL: '',
    OperatorEmail: '',
    MasterOperator: false,
  });
  // 'Url', 'IP Address',
  // Example validation state
  const [errors, setErrors] = useState({
    operatorName: '',
    FortressURL: '',
    OperatorEmail: '',
  });

  const validateForm = () => {
    const newErrors = {
      operatorName: '',
      FortressURL: '',
      OperatorEmail: '',
    };

    if (!newOperatorProfile.operatorName.trim()) {
      newErrors.operatorName = t('tools.operators.errNameRequired');
    }

    if (!newOperatorProfile.FortressURL.trim()) {
      newErrors.FortressURL = t('tools.operators.errFortressRequired');
    } else if (!/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}\/?$/.test(newOperatorProfile.FortressURL)) {
      newErrors.FortressURL = t('tools.operators.errFortressInvalid');
    }
    if (!newOperatorProfile.OperatorEmail.trim()) {
      newErrors.OperatorEmail = t('tools.operators.errEmailRequired');
    } else if (!/\S+@\S+\.\S+/.test(newOperatorProfile.OperatorEmail)) {
      newErrors.OperatorEmail = t('tools.operators.errEmailInvalid');
    }

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === '');
  };

  useEffect(() => {
    const email = localStorage.getItem('email');
    if (email) {
      setUserEmail(email);
    }
  }, []);

  useEffect(() => {
    if (userEmail) {
      fetchSubOperatorsData(userEmail);
    }
  }, [userEmail]);

  async function fetchSubOperatorsData(email: string) {
    try {
      const payload = {
        size: 500,
      };
      const response = await axios.get(`/v2/op/master-operator/${email}/sub-operators`, { params: payload });
      setSubOperatorsData(response.data.data);

      const disabledMap: { [key: string]: boolean } = {};
      response.data.data.forEach((op: any) => {
        disabledMap[op['Operator Key']] = op.Disabled;
      });
      setSubOperatorsDisabledMap(disabledMap);
      console.log('Sub-operators data:', subOperatorsDisabledMap);
    } catch (error) {
      console.error('Error fetching sub-operators data:', error);
    }
    fetchOperatorData (); // Fetch operator data after fetching sub-operators
    fetchApi(); // Fetch port scan jobs after fetching operator data
  }

  const handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    if (validateForm()) {
      createNewOperator();
    }
  };

  async function fetchApi() {
    try {
      const getAllJobs = await axios.get(`https://portcullis.blackdice.ai/v1/jobs/by-operator/${operatorId}`);
      setAllScanData([...getAllJobs.data].reverse());
    } catch (error) {
      console.error('Error fetching port scan jobs: ', error);
    }
  }
  async function fetchOperatorData() {
    const payload = {
      page: currentPageOp,
      size: 500,
      type: 'operators',
      operatorId: operatorId,
    };
    const accountsAndData = await axios.get(`/v2/op/master-operator/get-operators-or-accounts`, { params: payload });
    console.log('Accounts and Data:', accountsAndData.data);
    setOperatorData(accountsAndData.data);
  }
  async function getOperatosAccount() {
    const payload = {
      page: currentPage,
      size: 500,
      type: 'accounts',
      operatorId: operatorId,
    };
    const accountsOperators = await axios.get(`/v2/op/master-operator/get-operators-or-accounts`, { params: payload });
    setOperatorAccountData(accountsOperators.data);
    setOperatorClicked(true);
  }

  const handlePageChange = (page: any) => {
    console.log('Page changed:', page);
    setCurrentPage(page);
  };
  const handlePageChangeOperators = (page: any) => {
    console.log('Page changed:', page);
    setCurrentPageOp(page);
  };

  useEffect(() => {
    const startIndex = (currentPage - 1) * pageSize; // Start index for the current page
    const endIndex = startIndex + pageSize; // End index for the current page

    // Slice the data based on the page and page size
    // const paginatedData = jobData?.PortSpecs?.slice(startIndex, endIndex);
    const paginatedData = allScanData?.slice(startIndex, endIndex);

    setFilteredData(paginatedData); // Set filtered data
  }, [currentPage, allScanData]);
  useEffect(() => {
    const startIndex = (currentPageOp - 1) * pageSize; // Start index for the current page
    const endIndex = startIndex + pageSize; // End index for the current page

    // Slice the data based on the page and page size
    // const paginatedData = jobData?.PortSpecs?.slice(startIndex, endIndex);
    const paginatedData = operatorData?.data?.slice(startIndex, endIndex);

    setFilteredOperatorData(paginatedData); // Set filtered data
  }, [currentPageOp, operatorData]);

  function statusChange(item: any) {
    console.log('Status changed:', item);
  }

  async function deleteOperatorAccount(operatorId: string | number, email: string) {
    try {
      const payload = {
        operatorId: String(operatorId), // 👈 Convert to string
        email: email,
      };

      const response = await axios.delete('/v2/op/master-operator/delete-operator-account', {
        data: payload,
        headers: { 'Content-Type': 'application/json' },
      });

      await getOperatosAccount(); // Refresh data
      return response.data;
    } catch (error) {
      console.error('Delete error:', error);
      throw error;
    }
  }

  async function refreshData() {
    try {
      const getAllJobs = await axios.get(`https://portcullis.blackdice.ai/v1/jobs/by-operator/${operatorId}`);
      showToastMessage(t('tools.scan.toastStatus', { percent: getAllJobs.data[getAllJobs.data.length - 1].PercentageComplete }));
      setAllScanData([...getAllJobs.data].reverse());
    } catch (error) {
      console.error('Error fetching port scan jobs: ', error);
    }
  }

  function submit(event: any, type: string) {
    if (type === 'url') {
      setUrlSearch(true);
    }

    if (type === 'ip') {
      setIpSearch(true);
    }

    if (type === 'scan') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (emailRegex.test(routerId as string)) {
        console.log('Verified Email Address!');
      } else {
        console.log('Please enter valid email address!');
      }
    }

    event.preventDefault();
  }

  const handleUrl = (target: HTMLInputElement) => {
    setUrl(target.value);
  };

  const handleIp = (target: HTMLInputElement) => {
    setIp(target.value);
  };

  const [ipKey, setIpKey] = useState<string>('');
  const [ipScore, setIpScore] = useState<number>(0);
  const [ipMessage, setIpMessage] = useState<string>('');
  const [urlMessage, setUrlMessage] = useState<string>('');
  const [abuseIpDb, setAbuseIpDb] = useState<any>();
  const [tableApiUrl, setTableApiUrl] = useState<any>();
  const [urlTableApiUrl, setUrlTableApiUrl] = useState<any>();
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [dayDifference, setDayDifference] = useState<any | null>(null);
  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    setEndDate(today);
  }, []);

  const ipSearchRedis = async () => {
    try {
      const findIp = await axios.get(`/v2/op/dns-records/ip-address-redis/${ip}`);
      const response = findIp.data.response;

      if (response.blocked) {
        setIpMessage(t('tools.ip.messageBlocked', { ip: response.key, score: response.score }));
      } else {
        setIpMessage(t('tools.ip.messageNotBlocked', { ip: response.key }));
      }

      const abuseIpData = await axios.get(`/v2/op/dns-records/abuse-ip/${ip}`);

      const abuseIpResponse = abuseIpData.data.ipData;
      let url = `v2/op/dns-records/abuse-ip/reports/${ip}`;
      setTableApiUrl(url);

      setAbuseIpDb(abuseIpResponse);
      setIpKey(response.key);
      setIpScore(response.score);
    } catch (error) {
      console.error(`An error has occurred whilst obtaining IP address from Redis Store: ${error}`);
    }
  };

  useEffect(() => {
    if (tableApiUrl) {
      console.log('URL changed:', tableApiUrl);
    }
  }, [tableApiUrl]);

  const handleRouterId = (target: HTMLInputElement) => {
    setRouterId(target.value);
  };

  const handleCve = (data: any) => {
    setIsClicked(true);
    setCveData(data);
  };

  function createNew() {
    setnewOpClicked(true);
  }
  function createNewAccount() {
    console.log('Creating new account:', accountProfile);
    setEditAccountClicked(true);
    setOperatorClicked(false);
    setNewAccountClicked(false);
  }
  const createNewOperator = async () => {
    try {
      console.log('Creating operator:', newOperatorProfile);
      const response = await axios.post(`/v2/op/master-operator/create-or-link-operator`, {
        name: newOperatorProfile.operatorName,
        domain: newOperatorProfile.FortressURL,
        email: newOperatorProfile.OperatorEmail,
        master: newOperatorProfile.MasterOperator,
        type: 'create',
        operatorId: operatorId,
      });
      showToastMessage(t('tools.operators.toastCreated'));
      console.log('Response:', response.data);
      setEditOpClicked(false);
      setnewOpClicked(false); // Close modal or toggle after successful create
    } catch (error) {
      showToastMessage(t('tools.operators.toastCreateError'), error);
      console.error('Error creating operator:', error);
    }
  };
  function saveOperator(operatorId: string) {
    console.log('Creating/updating operator:', operatorProfile);
    modifyOperator(operatorId);
    setEditOpClicked(false);
    setnewOpClicked(false);
  }
  const toggleOperatorStatus = async (subOperatorId: string, isEnabled: boolean, name: string) => {
    try {
      const actionType = isEnabled ? 'enable' : 'disable'; // Corrected this line
      const endpoint = `v2/op/master-operator/${operatorId}/disable-operator/${subOperatorId}?type=${actionType}`;
      console.log('Sending PATCH request to:', endpoint);
      const response = await axios.patch(endpoint);

      // Update local state if API call succeeds
      setSubOperatorsDisabledMap((prev) => ({
        ...prev,
        [subOperatorId]: !isEnabled,
      }));

      showToastMessage(!isEnabled ? t('tools.operators.toastDisabled') : t('tools.operators.toastEnabled'));
    } catch (error: any) {
      console.error('Error toggling operator status:', error.response?.data || error.message);
      showToastMessage(t('tools.operators.toastStatusFailed'));

      // Revert the switch if the API call fails
      setSwitchStates((prev) => ({
        ...prev,
        [subOperatorId]: !prev[subOperatorId],
      }));
    }
  };

  const modifyOperator = async (id: string) => {
    try {
      const response = await axios.patch(`/v2/op/master-operator/edit-operator`, {
        name: operatorProfile.operatorName,
        domain: operatorProfile.FortressURL,
        email: operatorProfile.OperatorEmail,
        master: operatorProfile.MasterOperator,
        operatorId: id,
      });
      showToastMessage(t('tools.operators.toastUpdated'));
      console.log('Response:', response.data);
      setEditOpClicked(false);
      setnewOpClicked(false); // Close modal or toggle after successful create
      fetchApi(); // Refresh data
    } catch (error) {
      showToastMessage(t('tools.operators.toastCreateError'), error);
      console.error('Error creating operator:', error);
    }
  };

  function backToOperatorlist() {
    setOperatorClicked(false);
  }
  useEffect(() => {
    window.localStorage.setItem('portData', JSON.stringify(previousSelectedIDs));
  }, [previousSelectedIDs]);

  useEffect(() => {
    const storedData = JSON.parse(window.localStorage.getItem('portData') || '[]');
    setPreviousSelectedIDs(storedData);
  }, []);

  const data = [
    { URL: 'https://www.amazon.com' },
    { category: 'Primary', value: 'Electronics' },
    { category: 'Secondary', value: 'Books' },
    { category: 'IAB Tier1', value: 'Home' },
    { category: 'IQG Content Rating', value: 'General' },
    { category: 'IQG Non Standard Classification', value: 'Standard' },
    { category: 'IQG Brand Safety', value: 'Safe' },
    { category: 'Security', value: 'Secure' },
    { category: 'Reputation', value: 'Trusted' },
    { category: 'Age Rating', value: 'All Ages' },
  ];

  const ipData = [
    { IP: '52.94.236.248' },
    { category: 'ISP', value: 'Amazon Technologies Inc.' },
    { category: 'Usage Type', value: 'Data Center/Web Hosting/Transit' },
    { category: 'Domain Name', value: 'amazon.com' },
    { category: 'Country', value: 'United States of America' },
    { category: 'City', value: 'Ashburn, Virginia' },
  ];

  function handleMenuClick(menuName: string) {
    setSelectedMenu(menuName);
  }

  function getTdValue(value: any) {
    return (
      <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">{value}</Tooltip>}>
        <div>{value}</div>
      </OverlayTrigger>
    );
  }

  var hw_addr: string, ip_address: string, api_key: string;

  type IdentifiedInput = {
    email: string | null;
    serialNumber: string | null;
    macAddress: string | null;
  };

  function identifyInput(input: string) {
    const patterns = {
      email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      serialNumber: /^[a-zA-Z0-9_-]{5,40}$/,
      macAddress: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/,
    };

    let result: IdentifiedInput = {
      email: '',
      serialNumber: '',
      macAddress: '',
    };

    for (const type in patterns) {
      if (patterns[type as keyof IdentifiedInput].test(input)) {
        result[type as keyof IdentifiedInput] = input;
        break;
      }
    }

    return result;
  }

  const sendScan = async (event: any) => {
    event.preventDefault();
    let type = identifyInput(routerId);

    const getHw_Addr = await axios
      .get(`/v2/op/router/${operatorId}/port-scan?email=${type.email}&serialNumber=${type.serialNumber}&macAddress=${type.macAddress}`)
      .then((response) => {
        showToastMessage(t('tools.scan.toastInitiated'));
        hw_addr = response.data['Device Address'];
        ip_address = response.data['IP Address'];
      })
      .catch((error) => {
        showToastMessage(t('tools.scan.toastFailed'));
        setErrorMessage(
          error.response.data.message
            ? error.response.data.message
            : t('tools.scan.invalidInput')
        );
        setRouterId('');
        console.log(error);
      });

    if (hw_addr && ip_address) {
      const sendScan = await axios.post(`https://portcullis.blackdice.ai/v1/on-demand`, {
        hw_addr: hw_addr,
        ip_address: ip_address,
        api_key: '',
        scan_type: '',
        operator_id: Number(operatorId),
      });
      setRouterId('');
      fetchApi();
    }
  };

  const getJobData = async (jobId: any) => {
    try {
      const results = await axios.get(`https://portcullis.blackdice.ai/v1/jobs/by-id/${jobId}`);
      setJobData(results.data);
      setPortClicked(true);
    } catch (error) {
      console.error('Error fetching port scan jobs: ', error);
    }
  };

  // console.log(previousSelectedIDs);
  function formatDate(dateString: string) {
    const [datePart, timePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-');
    const [hours, minutes, seconds] = timePart.split(':');
    const formattedSeconds = seconds.split('.')[0];

    return `${day}-${month}-${year} ${hours}:${minutes}:${formattedSeconds}`;
  }

  const removePort = (id: number) => {
    setPreviousSelectedIDs((prevSelectedIDs) => {
      const newSelectedIDs = [...prevSelectedIDs];
      newSelectedIDs.splice(id, 1);
      return newSelectedIDs;
    });
  };

  // Functions to fetch URL Lookup
  const [urlPie, setUrlPie] = useState<UrlData[]>([]);

  const fetchUrlLookup = async () => {
    try {
      setUrlTableApiUrl(`v2/op/dns-records/fetch-url-lookup/${url}`);
      const fetchIps = await axios.get(`v2/op/dns-records/fetch-url-lookup/${url}?page=1&size=9`);
      const res = fetchIps.data.data;
      setUrlPie(res);
      const ips = fetchIps.data.ipAddress;
      if (ips?.length === 1) {
        setUrlMessage(t('tools.url.messageSingleIp', { url, ip: ips[0] }));
      } else if (ips?.length > 1) {
        setUrlMessage(t('tools.url.messageMultipleIps', { url, ips: ips.join(', ') }));
        console.log('AJAY ', urlMessage);
      } else {
        setUrlMessage(t('tools.url.noIps', { url }));
      }

      return urlTableApiUrl;
    } catch (error) {
      console.error('Error fetching URL Lookup:', error);
    }
  };
  function editMasterOp(item: any) {
    setEditOpClicked(true);
    const profile: OperatorProfile = {
      operatorId: String(item.operatorId),
      operatorName: item.name,
      FortressURL: item.fortress,
      OperatorEmail: item.email,
      MasterOperator: item.masterControl,
    };
    setOperatorProfile(profile);
    console.log('Edit Master Operator:', item);
  }
  function editAccounts(item: any) {
    setEditAccountClicked(true);
    setOperatorClicked(false);
    const profile: AccountProfile = {
      id: item.id,
      email: item.email,
    };
    setAccountProfile(profile);
    console.log('Edit Accounts:', item);
  }
  // function newAccounts(item: any) {
  //   setEditAccountClicked(true);
  //   setOperatorClicked(false);
  //   const profile: AccountProfile = {
  //     id: item.id,
  //     email: item.email,
  //   };
  //   setAccountProfile(profile);
  //   console.log('Edit Accounts:', item);
  // }
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value, type, checked } = e.target;

    setOperatorProfile((prev) => ({
      ...prev,
      [id]: type === 'checkbox' ? checked : value,
    }));
  };
  const handleAccountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value, type, checked } = e.target;

    setAccountProfile((prev) => ({
      ...prev,
      [id]: type === 'checkbox' ? checked : value,
    }));
  };
  const handleNewAccountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value, type, checked } = e.target;

    setAccountProfile((prev) => ({
      ...prev,
      [id]: type === 'checkbox' ? checked : value,
    }));
  };
  const handleNewOpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value, checked } = e.target;

    setNewOperatorProfile((prev) => {
      const updated = { ...prev };

      switch (id) {
        case 'operatorName':
          updated.operatorName = value;
          break;
        case 'FortressURL':
          updated.FortressURL = value;
          break;
        case 'OperatorEmail':
          updated.OperatorEmail = value;
          break;
        case 'MasterOperator':
          updated.MasterOperator = checked;
          break;
        default:
          break;
      }

      return updated;
    });
  };

  useEffect(() => {
    if (urlTableApiUrl) {
      console.log('URL changed:', urlTableApiUrl);
      console.log('URL message: ', urlMessage);
    }
  }, [urlTableApiUrl]);

  const [pieChart, setPieChart] = useState<{
    series: number[];
    options: ApexOptions;
  }>({
    series: [33.3, 66.7], // Example values
    options: {
      chart: {
        type: 'donut',
      },
      labels: ['Allowed', 'Blocked'],
      plotOptions: {
        pie: {
          expandOnClick: false,
        },
      },
      title: {
        text: 'Age Profile Status',
        align: 'left',
        margin: 10,
        style: {
          fontSize: '16px',
          fontWeight: 'bold',
          color: '#263238',
        },
      },
      subtitle: {
        text: 'Percentage of blocked vs allowed URLs across age profiles',
        align: 'left',
        margin: 20,
        style: {
          fontSize: '14px',
          fontWeight: 'normal',
          color: '#9699a2',
        },
      },
      legend: {
        position: 'top', // Default position of legend
        horizontalAlign: 'center',
        itemMargin: {
          horizontal: 10,
          vertical: 15,
        },
      },

      // legend: {
      //   position: 'right',
      //   horizontalAlign: 'center',
      //   offsetY: 50,
      //   itemMargin: {
      //     vertical: 10, // Spacing between legend items
      //     horizontal: 5,
      //   },
      //   markers: {
      //     width: 12,
      //     height: 12,
      //     radius: 12,
      //   },
      //   labels: {
      //     useSeriesColors: true,
      //   },
      //   fontSize: '14px',
      // },
      colors: ['#35B888', '#F84D4D'], // Red for Blocked, Green for Allowed
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: { width: 200 },
            legend: { position: 'bottom' },
          },
        },
      ],
    },
  });

  useEffect(() => {
    // Ensure urlPie exists and has data
    if (urlPie && urlPie.length > 0) {
      const statusCounts = urlPie.reduce(
        (acc, { Status }) => {
          if (Status === 'Blocked') acc.blocked += 1;
          else if (Status === 'Allowed') acc.allowed += 1;

          return acc;
        },
        { allowed: 0, blocked: 0 } // Initialize counts
      );

      const series = [statusCounts.allowed, statusCounts.blocked]; // Populate series

      setPieChart((prev) => ({
        ...prev,
        series: series, // Update series dynamically
      }));
    }
  }, [urlPie]); // Ensure urlPie triggers effect when it changes

  // const [listModels, setListModels] = useState<any>();

  const vendors = [
    { vendor: 'huawei', model: 'hg8245q2' },
    { vendor: 'huawei', model: 'hn8145x6' },
    { vendor: 'kontron', model: 'innbox_e94' },
    { vendor: 'linksys', model: 'mbe70' },
    { vendor: 'mercku', model: 'm6-m6a' },
    { vendor: 'ruijie', model: 'eg-2100-p' },
    { vendor: 'sagemcom', model: '5670' },
    { vendor: 'raspberry', model: 'pi_4' },
  ];

  const [selectedRouterModel, setSelectedRouterModel] = useState<any>();
  const [agentType, setAgentType] = useState<string>('');
  const [showAgentConfirmation, setShowAgentConfirmation] = useState<boolean>(false);
  const [confirmationMessage, setConfirmationMessage] = useState<string>('');
  const [confirmationTitle, setConfirmationTitle] = useState<string>('');
  const [startBootloader, setStartBootloader] = useState<boolean>(false);
  const [inputCpeId, setInputCpeId] = useState<any>('');
  const [agentAll, setAgentAll] = useState<boolean>(false);
  const [agentAllText, setAgentAllText] = useState<string>('');
  const handleAgentModelList = (event: any) => {
    setSelectedRouterModel(event);
  };

  const handleAgentCpeInput = (event: any) => {
    setInputCpeId(event.target.value);
  };

  const handleAgentAll = (event: any) => {
    setAgentAllText(event.target.value);
    if (event.target.value === 'CONFIRM') {
      setAgentAll(true);
    }
  };

  const handleStartBootloader = async () => {
    setEnableAgent(true);
    if (agentType === 'cpe') {
      setConfirmationTitle(t('tools.agent.startCpeTitle', { cpeId: inputCpeId }));
      setConfirmationMessage(t('tools.agent.startCpeMessage', { cpeId: inputCpeId }));
      setShowAgentConfirmation(true);
    } else if (agentType === 'model') {
      setConfirmationTitle(t('tools.agent.startModelTitle', { vendor: selectedRouterModel?.vendor, model: selectedRouterModel?.model }));
      setConfirmationMessage(t('tools.agent.startModelMessage', { vendor: selectedRouterModel?.vendor, model: selectedRouterModel?.model }));
      setShowAgentConfirmation(true);
    } else if (agentType === 'all') {
      setConfirmationTitle(t('tools.agent.startAllTitle'));
      setConfirmationMessage(t('tools.agent.startAllMessage'));
      setShowAgentConfirmation(true);
    }
  };

  const handleStopBootloader = () => {
    setEnableAgent(false);
    if (agentType === 'cpe') {
      setConfirmationTitle(t('tools.agent.stopCpeTitle', { cpeId: inputCpeId }));
      setConfirmationMessage(t('tools.agent.stopCpeMessage', { cpeId: inputCpeId }));
      setShowAgentConfirmation(true);
    } else if (agentType === 'model') {
      setConfirmationTitle(t('tools.agent.stopModelTitle', { vendor: selectedRouterModel?.vendor, model: selectedRouterModel?.model }));
      setConfirmationMessage(t('tools.agent.stopModelMessage', { vendor: selectedRouterModel?.vendor, model: selectedRouterModel?.model }));
      setShowAgentConfirmation(true);
    } else if (agentType === 'all') {
      setConfirmationTitle(t('tools.agent.stopAllTitle'));
      setConfirmationMessage(t('tools.agent.stopAllMessage'));
      setShowAgentConfirmation(true);
    }
  };

  const handleBootloaderConfirmation = async () => {
    if (enableAgent) {
      if (agentType === 'cpe') {
        showToastMessage(t('tools.agent.toastStartedCpe', { cpeId: inputCpeId }));
        await handleBootloaderRequest();
      } else if (agentType === 'model') {
        showToastMessage(t('tools.agent.toastStartedModel', { vendor: selectedRouterModel?.vendor, model: selectedRouterModel?.model }));
        await handleBootloaderRequest();
      } else if (agentType === 'all') {
        if (agentAll) {
          setAgentAllText('');
          console.log(agentAllText);
          showToastMessage(t('tools.agent.toastStartedAll'));
          setAgentAll(false);
          await handleBootloaderRequest();
        } else {
          showToastMessage(t('tools.agent.toastConfirmFailed'));
        }
      }
    } else {
      if (agentType === 'cpe') {
        showToastMessage(t('tools.agent.toastStoppedCpe', { cpeId: inputCpeId }));
        await handleBootloaderRequest();
      } else if (agentType === 'model') {
        showToastMessage(t('tools.agent.toastStoppedModel', { vendor: selectedRouterModel?.vendor, model: selectedRouterModel?.model }));
        await handleBootloaderRequest();
      } else if (agentType === 'all') {
        if (agentAll) {
          showToastMessage(t('tools.agent.toastStoppedAll'));
          setAgentAll(false);
          await handleBootloaderRequest();
        } else {
          showToastMessage(t('tools.agent.toastConfirmFailed'));
        }
      }
    }
  };

  const handleBootloaderRequest = async () => {
    try {
      let model = selectedRouterModel?.model ? selectedRouterModel?.model : '';
      let vendor = selectedRouterModel?.vendor ? selectedRouterModel?.vendor : '';
      await axios.patch(
        `/v2/op/master-operator/start-stop/agent?cpeId=${inputCpeId}&isActive=${enableAgent}&type=${agentType}&vendor=${vendor}&model=${model}`
      );
      console.log(
        `/v2/op/master-operator/start-stop/agent?cpeId=${inputCpeId}&isActive=${enableAgent}&type=${agentType}&vendor=${vendor}&model=${model}`
      );
    } catch (error) {
      console.error('Error updating agent bootloader status: ', error);
    }
  };

  useEffect(() => {
    if (agentType && startBootloader) {
      handleStartBootloader();
    }
    if (agentType && !startBootloader) {
      handleStopBootloader();
    }
  }, [agentType, startBootloader]);

  const tabIcons: Record<string, LucideIcon> = {
    Url: Link2,
    'IP Address': Network,
    'Port Scanning': Radar,
    Operators: Users,
    Agent: Bot,
  };

  const tabLabels: Record<string, string> = {
    'Port Scanning': t('tools.tabs.portScanning'),
    Url: t('tools.tabs.url'),
    Operators: t('tools.tabs.operators'),
    Agent: t('tools.tabs.agent'),
  };

  // nmap port states come from the scanner; unknown values are shown as-is
  const portStateLabels: Record<string, string> = {
    open: t('tools.portState.open'),
    closed: t('tools.portState.closed'),
    filtered: t('tools.portState.filtered'),
  };

  const localizedPieOptions: ApexOptions = {
    ...pieChart.options,
    labels: [t('tools.chart.allowed'), t('tools.chart.blocked')],
    title: { ...pieChart.options.title, text: t('tools.chart.title') },
    subtitle: { ...pieChart.options.subtitle, text: t('tools.chart.subtitle') },
  };

  return (
    <section className="bd ot-page" data-theme={Props.darkmode ? 'dark' : 'light'} data-accent="mint">
<div className="ot-wrap">
  {/* Header */}
  <header className="bd-page-hd">
    <span className="bd-eyebrow">{t('tools.page.eyebrow')}</span>
    <h1 className="bd-h1 bd-page-title">{t('tools.page.title')}</h1>
    <span className="bd-body">{t('tools.page.subtitle')}</span>
  </header>

  {/* Tabs Navigation */}
  <div className="bd-tabbar" role="tablist" aria-label={t('tools.page.eyebrow')}>
    {menuList.map((item) => {
      const Icon = tabIcons[item] || Wrench;
      const active = selectedMenu === item;
      return (
        <button
          key={item}
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => handleMenuClick(item)}
          className={`bd-tabbar-item ${active ? 'active' : ''}`}
        >
          <Icon size={16} strokeWidth={1.9} />
          <span>{tabLabels[item] ?? item}</span>
        </button>
      );
    })}
  </div>

  {/* Tab Content Container */}
  <div className="tab-content">
    {/* URL Tab */}
    {selectedMenu === 'Url' && (
      <div className="card bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="p-4 md:p-6">
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
              <div className="p-2 bg-blue-50 rounded-lg">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="text-blue-600">
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" 
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" 
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              {t('tools.url.heading')}
            </h3>
            <form onSubmit={(e) => submit(e, 'url')} className="flex flex-col md:flex-row gap-3 items-start md:items-center">
              <div className="flex-1">
                <input
                  type="text"
                  value={url}
                  onChange={(e) => handleUrl(e.target)}
                  placeholder={t('tools.url.placeholder')}
                  className="w-full border-2 border-gray-300 p-3 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-colors"
                />
              </div>
              <button 
                className="bg-[#35b888] hover:bg-[#2da075] text-white font-semibold px-6 py-3 rounded-lg transition-all duration-200 hover:shadow-lg hover:shadow-[#35b888]/25 flex items-center gap-2"
                onClick={fetchUrlLookup}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" 
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                {t('tools.url.analyze')}
              </button>
            </form>
          </div>

          {urlSearch && (
            <div className="space-y-6">
              <div className={`p-4 rounded-lg ${
                urlMessage?.toLowerCase().includes('safe') || urlMessage?.toLowerCase().includes('clear') 
                  ? 'bg-green-50 border border-green-200' 
                  : 'bg-red-50 border border-red-200'
              }`}>
                <h4 className="text-lg font-semibold mb-2 flex items-center gap-2">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className={
                    urlMessage?.toLowerCase().includes('safe') || urlMessage?.toLowerCase().includes('clear') 
                      ? 'text-green-600' 
                      : 'text-red-600'
                  }>
                    <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  {t('tools.url.resultTitle')}
                </h4>
                <p className={`font-medium ${
                  urlMessage?.toLowerCase().includes('safe') || urlMessage?.toLowerCase().includes('clear') 
                    ? 'text-green-800' 
                    : 'text-red-800'
                }`}>
                  {urlMessage}
                </p>
              </div>

              {urlTableApiUrl && (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
                    <h5 className="text-lg font-semibold text-gray-800 mb-4">{t('tools.url.threatDistribution')}</h5>
                    <ReactApexChart 
                      options={localizedPieOptions} 
                      series={pieChart.series} 
                      type="donut" 
                      height={320} 
                    />
                  </div>
                  <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
                    <div className="p-4 border-b border-gray-200 bg-gray-50">
                      <h5 className="text-lg font-semibold text-gray-800">{t('tools.url.ageProfilesByDomain', { url })}</h5>
                      <p className="text-sm text-gray-500 mt-1">{t('tools.url.detailedResults')}</p>
                    </div>
                    <div className="p-4">
                      <TableWidget
                        hasSearch={false}
                        url={urlTableApiUrl}
                        countPerPage={8}
                        key={urlTableApiUrl}
                        title={t('tools.url.ageProfilesByDomain', { url })}
                        searchPositionRight={true}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    )}

    {/* IP Address Tab */}
    {selectedMenu === 'IP Address' && (
      <div className="card bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="p-4 md:p-6">
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
              <div className="p-2 bg-purple-50 rounded-lg">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="text-purple-600">
                  <path d="M16 2V6M8 2V6M3 10H21M5 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6C3 4.89543 3.89543 4 5 4Z" 
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              {t('tools.ip.heading')}
            </h3>
            <form onSubmit={(e) => submit(e, 'ip')} className="flex flex-col md:flex-row gap-3 items-start md:items-center">
              <div className="flex-1">
                <input
                  type="text"
                  value={ip}
                  onChange={(e) => handleIp(e.target)}
                  placeholder={t('tools.ip.placeholder')}
                  className="w-full border-2 border-gray-300 p-3 rounded-lg focus:outline-none focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-colors"
                />
              </div>
              <button 
                className="bg-[#35b888] hover:bg-[#2da075] text-white font-semibold px-6 py-3 rounded-lg transition-all duration-200 hover:shadow-lg hover:shadow-[#35b888]/25 flex items-center gap-2"
                onClick={ipSearchRedis}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" 
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                {t('tools.ip.analyze')}
              </button>
            </form>
          </div>

          {ipSearch && (
            <div className="space-y-6">
              <div className={`p-4 rounded-lg ${
                abuseIpDb?.abuseConfidenceScore > 50 
                  ? 'bg-red-50 border border-red-200' 
                  : 'bg-green-50 border border-green-200'
              }`}>
                <h4 className="text-lg font-semibold mb-2 flex items-center gap-2">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className={
                    abuseIpDb?.abuseConfidenceScore > 50 ? 'text-red-600' : 'text-green-600'
                  }>
                    <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  {t('tools.ip.resultTitle')}
                </h4>
                <p className={`font-medium ${
                  abuseIpDb?.abuseConfidenceScore > 50 ? 'text-red-800' : 'text-green-800'
                }`}>
                  {ipMessage}
                </p>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="lg:col-span-1">
                  <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
                    <h5 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" className="text-gray-600">
                        <path d="M12 20H21M3 20H4.67454C5.16372 20 5.40832 20 5.63849 20.9447C5.84256 20.8957 6.03765 20.8149 6.2166 20.7053C6.41843 20.5816 6.59138 20.4086 6.93729 20.0627L21 6C21 6 17.5 5.5 12 11C6.5 16.5 6 13 6 13C6 13 4.5 18.5 10 13C15.5 7.5 14.5 4 14.5 4L2.93726 17.5627C2.59136 17.9086 2.4184 18.0816 2.29472 18.2834C2.18506 18.4624 2.10425 18.6574 2.05526 18.8615C2 19.0917 2 19.3363 2 19.8255V21" 
                          stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      {t('tools.ip.details')}
                    </h5>
                    <div className="space-y-3">
                      <div className="flex justify-between items-center pb-2 border-b border-gray-100">
                        <span className="text-sm font-medium text-gray-600">{t('tools.common.ipAddress')}</span>
                        <span className="font-semibold text-gray-800">{abuseIpDb?.ip}</span>
                      </div>
                      <div className="flex justify-between items-center pb-2 border-b border-gray-100">
                        <span className="text-sm font-medium text-gray-600">{t('tools.ip.domain')}</span>
                        <span className="font-semibold text-gray-800">{abuseIpDb?.domain}</span>
                      </div>
                      <div className="flex justify-between items-center pb-2 border-b border-gray-100">
                        <span className="text-sm font-medium text-gray-600">{t('tools.ip.country')}</span>
                        <span className="font-semibold text-gray-800">{abuseIpDb?.countryName} ({abuseIpDb?.countryCode})</span>
                      </div>
                      <div className="flex justify-between items-center pb-2 border-b border-gray-100">
                        <span className="text-sm font-medium text-gray-600">ISP</span>
                        <span className="font-semibold text-gray-800">{abuseIpDb?.isp}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-sm font-medium text-gray-600">{t('tools.ip.abuseConfidence')}</span>
                        <span className={`font-bold ${
                          abuseIpDb?.abuseConfidenceScore > 50 ? 'text-red-600' : 'text-green-600'
                        }`}>
                          {abuseIpDb?.abuseConfidenceScore}%
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="lg:col-span-2">
                  <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm h-full">
                    <div className="p-4 border-b border-gray-200 bg-gray-50">
                      <h5 className="text-lg font-semibold text-gray-800">{t('tools.ip.reportsForDomain', { domain: abuseIpDb?.domain })}</h5>
                      <p className="text-sm text-gray-500 mt-1">{t('tools.ip.reportsSubtitle')}</p>
                    </div>
                    <div className="p-4 h-full">
                      <TableWidget
                        hasSearch={true}
                        url={tableApiUrl}
                        countPerPage={8}
                        key={tableApiUrl}
                        title={t('tools.ip.reportsTableTitle', { domain: abuseIpDb?.domain })}
                        searchPositionRight={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )}

    {/* Port Scanning Tab */}
    {selectedMenu === 'Port Scanning' && (
      <div className="card bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="p-4 md:p-6">
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
              <div className="p-2 bg-orange-50 rounded-lg">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="text-orange-600">
                  <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                    stroke="currentColor" strokeWidth="2"/>
                  <path d="M12 8V12L14.5 14.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              {t('tools.tabs.portScanning')}
            </h3>
            <form onSubmit={sendScan} className="flex flex-col md:flex-row gap-3 items-start md:items-center">
              <div className="flex-1">
                <input
                  ref={inputRef}
                  type="text"
                  value={routerId}
                  onChange={(e) => handleRouterId(e.target)}
                  placeholder={t('tools.scan.placeholder')}
                  className="w-full border-2 border-gray-300 p-3 rounded-lg focus:outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-colors"
                />
                {errorMessage && <span className="text-red-500 mt-2 text-sm">{errorMessage}</span>}
              </div>
              <button 
                className="bg-[#35b888] hover:bg-[#2da075] text-white font-semibold px-6 py-3 rounded-lg transition-all duration-200 hover:shadow-lg hover:shadow-[#35b888]/25 flex items-center gap-2"
                type="submit"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                    stroke="currentColor" strokeWidth="2"/>
                  <path d="M12 8V12L14.5 14.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                {t('tools.scan.request')}
              </button>
            </form>
          </div>

          {!portClicked && filteredData && (
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
              <div className="p-4 border-b border-gray-200 bg-gray-50">
                <h5 className="text-lg font-semibold text-gray-800">{t('tools.scan.jobsTitle')}</h5>
                <p className="text-sm text-gray-500 mt-1">{t('tools.scan.jobsSubtitle')}</p>
              </div>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">ID</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.common.ipAddress')}</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.common.status')}</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.common.actions')}</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {filteredData.map((item: any, index: number) => (
                      <tr key={index} className="hover:bg-gray-50 transition-colors">
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{item.ID}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item.IPAddress}</td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className={`px-2 py-1 text-xs rounded-full font-semibold ${
                            item.State === 'COMPLETED' 
                              ? 'bg-green-100 text-green-800' 
                              : item.State === 'FAILED'
                              ? 'bg-red-100 text-red-800'
                              : 'bg-blue-100 text-blue-800'
                          }`}>
                            {item.State === 'COMPLETED' 
                              ? t('tools.scan.completed') 
                              : t('tools.scan.percentCompleted', { percent: item.PercentageComplete })}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm">
                          {item.State === 'COMPLETED' ? (
                            <button
                              onClick={() => getJobData(item.ID)}
                              className="bg-[#35b888] hover:bg-[#2da075] text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2"
                            >
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" 
                                  stroke="currentColor" strokeWidth="2"/>
                                <path d="M2.45825 12C3.73253 7.94288 7.52281 5 12.0004 5C16.4781 5 20.2684 7.94291 21.5426 12C20.2684 16.0571 16.4781 19 12.0004 19C7.52281 19 3.73253 16.0571 2.45825 12Z" 
                                  stroke="currentColor" strokeWidth="2"/>
                              </svg>
                              {t('tools.scan.viewResults')}
                            </button>
                          ) : (
                            <button
                              onClick={refreshData}
                              className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2"
                            >
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" className="animate-spin">
                                <path d="M12 4V1L8 5l4 4V6c3.87 0 7 3.13 7 7s-3.13 7-7 7-7-3.13-7-7h-2c0 4.97 4.03 9 9 9s9-4.03 9-9-4.03-9-9-9z" 
                                  stroke="currentColor" strokeWidth="2"/>
                              </svg>
                              {t('tools.scan.refresh')}
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="p-4 border-t border-gray-200 bg-gray-50">
                <Pagination
                  className="pagination"
                  current={currentPage}
                  pageSize={pageSize}
                  total={allScanData.length}
                  onChange={handlePageChange}
                  nextIcon={<CustomNextIcon />}
                  prevIcon={<CustomPreviousIcon />}
                />
              </div>
            </div>
          )}

          {portClicked && jobData && (
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
              <div className="p-4 border-b border-gray-200 bg-gray-50 flex justify-between items-center">
                <div className="flex items-center gap-3">
                  <button
                    onClick={() => setPortClicked(false)}
                    className="text-gray-600 hover:text-gray-800 transition-colors flex items-center gap-2"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    {t('tools.scan.backToJobs')}
                  </button>
                </div>
                <div className="flex items-center gap-4">
                  <span className="text-sm text-gray-600">{t('tools.scan.jobId')} <strong>{jobData.ID}</strong></span>
                </div>
              </div>
              
              <div className="p-6 space-y-6">
                {/* Job Info Card */}
                <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-5 border border-blue-200">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div>
                      <h6 className="text-sm font-semibold text-blue-800 mb-2">{t('tools.scan.basicInfo')}</h6>
                      <div className="space-y-2">
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600">{t('tools.scan.hwAddress')}</span>
                          <span className="text-sm font-medium text-gray-800">{jobData.HwAddr}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600">{t('tools.scan.ipAddressLabel')}</span>
                          <span className="text-sm font-medium text-gray-800">{jobData.IPAddress}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600">{t('tools.scan.scanned')}</span>
                          <span className="text-sm font-medium text-gray-800">{jobData.StartTime}</span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <h6 className="text-sm font-semibold text-blue-800 mb-2">{t('tools.scan.scanDetails')}</h6>
                      <div className="space-y-2">
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600">{t('tools.scan.stateLabel')}</span>
                          <span className="text-sm font-medium text-gray-800">{jobData.State}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600">{t('tools.scan.elapsed')}</span>
                          <span className="text-sm font-medium text-gray-800">{jobData.Elapsed}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600">{t('tools.scan.scanType')}</span>
                          <span className="text-sm font-medium text-gray-800">{jobData.ScanType}</span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <h6 className="text-sm font-semibold text-blue-800 mb-2">{t('tools.scan.portStats')}</h6>
                      <div className="space-y-2">
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600">{t('tools.scan.openPortsLabel')}</span>
                          <span className="text-sm font-medium text-gray-800">{jobData.OpenPorts}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600">{t('tools.scan.portsScanned')}</span>
                          <span className="text-sm font-medium text-gray-800">{jobData.PortsScanned}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-600">{t('tools.scan.operatorIdLabel')}</span>
                          <span className="text-sm font-medium text-gray-800">{jobData.OperatorID}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Port Specifications Table */}
                <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                  <div className="p-4 border-b border-gray-200 bg-gray-50">
                    <h5 className="text-lg font-semibold text-gray-800">{t('tools.scan.portSpecsTitle')}</h5>
                    <p className="text-sm text-gray-500 mt-1">{t('tools.scan.portSpecsSubtitle')}</p>
                  </div>
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">ID</th>
                          <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.scan.colOpenPorts')}</th>
                          <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.scan.colPortSpecs')}</th>
                          <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.scan.colState')}</th>
                          <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.scan.colUpdatedAt')}</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        <tr className="hover:bg-gray-50 transition-colors">
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{jobData.ID}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{jobData.OpenPorts}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{jobData.PortSpecs}</td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className={`px-2 py-1 text-xs rounded-full font-semibold ${
                              jobData.State === 'COMPLETED' 
                                ? 'bg-green-100 text-green-800' 
                                : 'bg-yellow-100 text-yellow-800'
                            }`}>
                              {jobData.State}
                            </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{jobData.UpdatedAt}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )}

          {portSearch && scanData && (
            <div className="mt-6 space-y-6">
              <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl p-5 border border-orange-200">
                <div className="flex justify-between items-center">
                  <div>
                    <h5 className="font-semibold text-orange-800 mb-1">{t('tools.scan.scanComplete')}</h5>
                    <div className="flex items-center gap-4 text-sm text-orange-700">
                      {scanData.timestamp && (
                        <span className="flex items-center gap-1">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                              stroke="currentColor" strokeWidth="2"/>
                            <path d="M12 8V12L14.5 14.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                          </svg>
                          {t('tools.scan.timestamp', { value: formatDate(scanData.timestamp) })}
                        </span>
                      )}
                      {scanData?.hosts?.[0]?.latency !== undefined && (
                        <span className="flex items-center gap-1">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path d="M12 8V12L14.5 14.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                          </svg>
                          {t('tools.scan.latency', {
                            value: (scanData.hosts[0].latency / 1000).toLocaleString(getLanguage(i18n.language).locale, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }),
                          })}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="px-3 py-1 bg-orange-100 text-orange-800 rounded-full text-xs font-semibold">
                    {t('tools.scan.portsFound', { count: scanData?.hosts?.[0]?.ports?.length || 0 })}
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
                <div className="p-4 border-b border-gray-200 bg-gray-50">
                  <h5 className="text-lg font-semibold text-gray-800">{t('tools.scan.resultsTitle')}</h5>
                  <p className="text-sm text-gray-500 mt-1">{t('tools.scan.resultsSubtitle')}</p>
                </div>
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.scan.colProtocol')}</th>
                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.scan.colPort')}</th>
                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.scan.colState')}</th>
                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.scan.colService')}</th>
                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.scan.colProduct')}</th>
                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.scan.colVersion')}</th>
                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">CVEs</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {scanData?.hosts?.[0]?.ports?.length > 0 ? (
                        scanData.hosts[0].ports.map((entry: any, index: number) => (
                          <tr key={index} className="hover:bg-gray-50 transition-colors">
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                              {getTdValue(entry.protocol)}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                              {getTdValue(entry.id)}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <span className={`px-2 py-1 text-xs rounded-full font-semibold ${
                                entry.state === 'open' ? 'bg-green-100 text-green-800' :
                                entry.state === 'closed' ? 'bg-red-100 text-red-800' :
                                'bg-gray-100 text-gray-800'
                              }`}>
                                {getTdValue(portStateLabels[entry.state] ?? entry.state)}
                              </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                              {getTdValue(entry.service.name)}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                              {getTdValue(entry.service.product)}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                              {getTdValue(entry.service.version)}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm">
                              {entry.service.cve_list && entry.service.cve_list.length > 0 ? (
                                <div className="flex flex-wrap gap-1">
                                  {entry.service.cve_list.map((cve: any, cveIndex: number) => (
                                    <button
                                      key={cveIndex}
                                      onClick={() => handleCve(cve)}
                                      className="px-2 py-1 bg-orange-100 text-orange-800 hover:bg-orange-200 rounded text-xs font-medium transition-colors"
                                    >
                                      {cve.cve_id}
                                    </button>
                                  ))}
                                </div>
                              ) : (
                                <span className="text-gray-400 text-xs">{t('tools.scan.noCves')}</span>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={7} className="px-6 py-4 text-center text-gray-500">
                            {t('tools.scan.noPorts')}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* CVE Detail Modal */}
          {isClicked && cveData && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white rounded-2xl shadow-2xl w-11/12 max-w-2xl overflow-hidden">
                <div className="p-6 border-b border-gray-200 bg-gradient-to-r from-orange-50 to-red-50">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="p-2 bg-gradient-to-br from-orange-500 to-red-500 rounded-lg">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="text-white">
                          <path d="M12 9V13M12 17H12.01M10.2679 4L3.33975 16C2.56995 17.3333 3.53216 19 5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0377 2.66667 10.2679 4Z"
                            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-900">{cveData.cve_id}</h3>
                        <p className="text-sm text-gray-600">{t('tools.cve.subtitle')}</p>
                      </div>
                    </div>
                    <button
                      onClick={() => setIsClicked(false)}
                      className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </button>
                  </div>
                </div>

                <div className="p-6 space-y-6">
                  <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl p-5 border border-gray-200">
                    <div className="flex items-center justify-between">
                      <div>
                        <h4 className="font-semibold text-gray-800 mb-1">{t('tools.cve.baseScore')}</h4>
                        <p className="text-sm text-gray-600">{t('tools.cve.severity')}</p>
                      </div>
                      <div className="text-right">
                        <div className="text-3xl font-bold text-gray-900">{cveData.score}</div>
                        <div className="text-sm text-gray-600">{t('tools.cve.outOf')}</div>
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <div>
                        <h5 className="font-semibold text-gray-700 mb-2 flex items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="text-blue-600">
                            <path d="M12 16V12M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                              stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                          </svg>
                          {t('tools.cve.description')}
                        </h5>
                        <p className="text-gray-600 bg-gray-50 p-3 rounded-lg border border-gray-200">
                          {cveData.description}
                        </p>
                      </div>
                    </div>

                    <div className="space-y-4">
                      <div>
                        <h5 className="font-semibold text-gray-700 mb-2 flex items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="text-purple-600">
                            <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          {t('tools.cve.sourceLink')}
                        </h5>
                        <a 
                          href={cveData.source} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="text-blue-600 hover:text-blue-800 hover:underline bg-blue-50 p-3 rounded-lg border border-blue-200 block break-all"
                        >
                          {cveData.source}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="p-6 border-t border-gray-200 bg-gray-50">
                  <div className="flex justify-end">
                    <button
                      onClick={() => setIsClicked(false)}
                      className="px-6 py-3 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white font-semibold rounded-lg transition-all duration-200 hover:shadow-lg"
                    >
                      {t('tools.cve.close')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )}

    {/* Operators Tab */}
    {selectedMenu === 'Operators' && (
      <div className="card bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="p-4 md:p-6">
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
              <div className="p-2 bg-green-50 rounded-lg">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="text-green-600">
                  <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" 
                    stroke="currentColor" strokeWidth="2"/>
                  <path d="M19.4 15C19.2661 15.3055 19.1334 15.6089 19.0019 15.9102C18.763 16.4714 18.6435 16.752 18.5148 17.0265C18.249 17.5969 17.9458 18.1487 17.6072 18.6786C17.4175 18.9852 17.2263 19.2905 17.0335 19.5944C16.6582 20.2055 16.4705 20.511 16.2375 20.7929C15.644 21.504 14.9372 22.1143 14.1481 22.5981C13.8645 22.7676 13.5766 22.9321 13.2844 23.0913C12.625 23.4536 11.9214 23.7262 11.1946 23.9021C10.872 23.9765 10.5469 24.0433 10.2194 24.1024C9.48231 24.2311 8.72986 24.2801 7.97855 24.2485C7.64841 24.2361 7.31933 24.2142 6.99144 24.1827C6.23594 24.1114 5.4961 23.9534 4.785 23.7128C4.46225 23.6039 4.1419 23.4859 3.82411 23.3589C3.15348 23.1002 2.51705 22.7568 1.93114 22.3371C1.65177 22.1317 1.37833 21.9192 1.11111 21.7L1 21.6"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              {t('tools.operators.heading')}
            </h3>
            
            <div className="flex justify-between items-center mb-6">
              {!newOpClicked && !operatorClicked && !editOpClicked && !editAccountClicked && (
                <button 
                  className="bg-[#35b888] hover:bg-[#2da075] text-white font-semibold px-6 py-3 rounded-lg transition-all duration-200 hover:shadow-lg hover:shadow-[#35b888]/25 flex items-center gap-2"
                  onClick={createNew}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  {t('tools.operators.createNew')}
                </button>
              )}
              
              {operatorClicked && (
                <button
                  onClick={backToOperatorlist}
                  className="text-gray-600 hover:text-gray-800 transition-colors flex items-center gap-2"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  {t('tools.operators.back')}
                </button>
              )}
            </div>
          </div>

          {/* Operators List */}
          {!operatorClicked && !newOpClicked && !editOpClicked && !editAccountClicked ? (
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
              <div className="p-4 border-b border-gray-200 bg-gray-50">
                <h5 className="text-lg font-semibold text-gray-800">{t('tools.operators.listTitle')}</h5>
                <p className="text-sm text-gray-500 mt-1">{t('tools.operators.listSubtitle')}</p>
              </div>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.common.status')}</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.operators.colOperatorId')}</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.operators.colName')}</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.operators.masterOperator')}</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.common.actions')}</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.common.details')}</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {filteredOperatorData?.map((item: any, index: number) => (
                      <tr key={index} className="hover:bg-gray-50 transition-colors">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <Switch
                            className="scale-80"
                            onChange={(checked) => {
                              setCurrentOperatorId(item.operatorId);
                              setCurrentOperatorName(item.Name);
                              setCurrentOperatorStatus(checked);
                              setShowConfirmationModal(true);

                              setSwitchStates((prev) => ({
                                ...prev,
                                [item.operatorId]: checked,
                              }));
                            }}
                            checked={
                              switchStates[item.operatorId]
                                ? switchStates[item.operatorId]
                                : !(subOperatorsDisabledMap[item.operatorId] ?? false)
                            }
                            disabled={item.operatorId.toString() === operatorId}
                            onColor={chartTokens[Props.darkmode ? 'dark' : 'light'].accent}
                            offColor={Props.darkmode ? '#35545c' : '#cfdcdc'}
                            checkedIcon={false}
                            uncheckedIcon={false}
                            height={22}
                            width={42}
                            handleDiameter={18}
                          />
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{item.operatorId}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item.name}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item.masterControl ? t('tools.common.yes') : t('tools.common.no')}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm">
                          <button
                            onClick={() => editMasterOp(item)}
                            className="bg-[#35b888] hover:bg-[#2da075] text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                              <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" 
                                stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                              <path d="M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z" 
                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            {t('tools.common.edit')}
                          </button>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm">
                          <button
                            onClick={() => getOperatosAccount()}
                            className="bg-gray-800 hover:bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                              <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" 
                                stroke="currentColor" strokeWidth="2"/>
                              <path d="M2.45825 12C3.73253 7.94288 7.52281 5 12.0004 5C16.4781 5 20.2684 7.94291 21.5426 12C20.2684 16.0571 16.4781 19 12.0004 19C7.52281 19 3.73253 16.0571 2.45825 12Z" 
                                stroke="currentColor" strokeWidth="2"/>
                            </svg>
                            {t('tools.common.details')}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="p-4 border-t border-gray-200 bg-gray-50">
                <Pagination
                  className="pagination"
                  current={currentPageOp}
                  pageSize={pageSize}
                  total={operatorData?.records}
                  onChange={handlePageChangeOperators}
                  nextIcon={<CustomNextIcon />}
                  prevIcon={<CustomPreviousIcon />}
                />
              </div>
            </div>
          ) : operatorClicked ? (
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
              <div className="p-4 border-b border-gray-200 bg-gray-50 flex justify-between items-center">
                <div>
                  <h5 className="text-lg font-semibold text-gray-800">{t('tools.operators.accountsTitle')}</h5>
                  <p className="text-sm text-gray-500 mt-1">{t('tools.operators.accountsSubtitle')}</p>
                </div>
                {!newAccountClicked && !editAccountClicked && (
                  <button 
                    className="bg-[#35b888] hover:bg-[#2da075] text-white font-semibold px-6 py-3 rounded-lg transition-all duration-200 hover:shadow-lg hover:shadow-[#35b888]/25 flex items-center gap-2"
                    onClick={createNewAccount}
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    {t('tools.operators.createNewAccount')}
                  </button>
                )}
              </div>
              
              {!editAccountClicked && !newAccountClicked ? (
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.operators.colAccountId')}</th>
                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.operators.colEmail')}</th>
                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.common.actions')}</th>
                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('tools.common.delete')}</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {operatorAccountData?.data?.map((item: any, index: number) => (
                        <tr key={index} className="hover:bg-gray-50 transition-colors">
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{item.id}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item.email}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm">
                            <button
                              onClick={() => editAccounts(item)}
                              className="bg-[#35b888] hover:bg-[#2da075] text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2"
                            >
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" 
                                  stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                <path d="M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z" 
                                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              {t('tools.common.edit')}
                            </button>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm">
                            <button className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                <path d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6" 
                                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              {t('tools.common.delete')}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="p-4 border-t border-gray-200 bg-gray-50">
                    <Pagination
                      className="pagination"
                      current={operatorAccountData?.page || 1}
                      pageSize={operatorAccountData?.size || 10}
                      total={operatorAccountData?.records || 0}
                      nextIcon={<CustomNextIcon />}
                      prevIcon={<CustomPreviousIcon />}
                    />
                  </div>
                </div>
              ) : editAccountClicked ? (
                <div className="p-6">
                  <h4 className="text-lg font-semibold text-gray-800 mb-4">{t('tools.operators.editAccount')}</h4>
                  <form className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">{t('tools.operators.colAccountId')}</label>
                      <input
                        id="id"
                        type="text"
                        value={accountProfile.id}
                        onChange={handleAccountChange}
                        className="w-full border-2 border-gray-300 p-3 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-colors"
                        readOnly
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">{t('tools.operators.emailAddress')}</label>
                      <input
                        id="email"
                        type="email"
                        value={accountProfile.email}
                        onChange={handleAccountChange}
                        className="w-full border-2 border-gray-300 p-3 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-colors"
                      />
                    </div>
                    <div className="flex justify-end gap-3">
                      <button
                        type="button"
                        onClick={() => setEditAccountClicked(false)}
                        className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-6 py-3 rounded-lg font-medium transition-colors"
                      >
                        {t('tools.common.cancel')}
                      </button>
                      <button
                        type="button"
                        onClick={() => saveOperator(accountProfile.id)}
                        className="bg-[#35b888] hover:bg-[#2da075] text-white px-6 py-3 rounded-lg font-medium transition-colors"
                      >
                        {t('tools.common.saveChanges')}
                      </button>
                    </div>
                  </form>
                </div>
              ) : newAccountClicked ? (
                <div className="p-6">
                  <h4 className="text-lg font-semibold text-gray-800 mb-4">{t('tools.operators.createNewAccount')}</h4>
                  <form className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">{t('tools.operators.colAccountId')}</label>
                      <input
                        id="id"
                        type="text"
                        value={accountProfile.id}
                        onChange={handleNewAccountChange}
                        className="w-full border-2 border-gray-300 p-3 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-colors"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">{t('tools.operators.emailAddress')}</label>
                      <input
                        id="email"
                        type="email"
                        value={accountProfile.email}
                        onChange={handleNewAccountChange}
                        className="w-full border-2 border-gray-300 p-3 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-colors"
                      />
                    </div>
                    <div className="flex justify-end gap-3">
                      <button
                        type="button"
                        onClick={() => setNewAccountClicked(false)}
                        className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-6 py-3 rounded-lg font-medium transition-colors"
                      >
                        {t('tools.common.cancel')}
                      </button>
                      <button
                        type="button"
                        onClick={() => saveOperator(accountProfile.id)}
                        className="bg-[#35b888] hover:bg-[#2da075] text-white px-6 py-3 rounded-lg font-medium transition-colors"
                      >
                        {t('tools.operators.createAccount')}
                      </button>
                    </div>
                  </form>
                </div>
              ) : null}
            </div>
          ) : editOpClicked ? (
            <div className="bg-white rounded-xl border border-gray-200 p-6">
              <h4 className="text-lg font-semibold text-gray-800 mb-6">{t('tools.operators.editOperator')}</h4>
              <form className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{t('tools.operators.operatorName')}</label>
                  <input
                    id="operatorName"
                    type="text"
                    value={operatorProfile.operatorName}
                    onChange={handleChange}
                    className="w-full border-2 border-gray-300 p-3 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{t('tools.operators.fortressUrl')}</label>
                  <input
                    id="FortressURL"
                    type="text"
                    value={operatorProfile.FortressURL}
                    onChange={handleChange}
                    className="w-full border-2 border-gray-300 p-3 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{t('tools.operators.operatorEmail')}</label>
                  <input
                    id="OperatorEmail"
                    type="email"
                    value={operatorProfile.OperatorEmail}
                    onChange={handleChange}
                    className="w-full border-2 border-gray-300 p-3 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-colors"
                  />
                </div>
                <div className="flex items-center gap-3">
                  <input
                    type="checkbox"
                    id="MasterOperator"
                    checked={operatorProfile.MasterOperator}
                    onChange={handleChange}
                    className="h-5 w-5 text-[#35b888] rounded focus:ring-[#35b888]"
                  />
                  <label htmlFor="MasterOperator" className="text-sm font-medium text-gray-700">
                    {t('tools.operators.masterOperator')}
                  </label>
                </div>
                <div className="flex justify-end gap-3">
                  <button
                    type="button"
                    onClick={() => setEditOpClicked(false)}
                    className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-6 py-3 rounded-lg font-medium transition-colors"
                  >
                    {t('tools.common.cancel')}
                  </button>
                  <button
                    type="button"
                    onClick={() => saveOperator(operatorProfile.operatorId)}
                    className="bg-[#35b888] hover:bg-[#2da075] text-white px-6 py-3 rounded-lg font-medium transition-colors"
                  >
                    {t('tools.common.saveChanges')}
                  </button>
                </div>
              </form>
            </div>
          ) : (
            <div className="bg-white rounded-xl border border-gray-200 p-6">
              <h4 className="text-lg font-semibold text-gray-800 mb-6">{t('tools.operators.createNew')}</h4>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{t('tools.operators.operatorName')}</label>
                  <input
                    id="operatorName"
                    type="text"
                    value={newOperatorProfile.operatorName}
                    onChange={handleNewOpChange}
                    className="w-full border-2 border-gray-300 p-3 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-colors"
                  />
                  {errors.operatorName && <p className="text-red-500 text-sm mt-2">{errors.operatorName}</p>}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{t('tools.operators.fortressUrl')}</label>
                  <input
                    id="FortressURL"
                    type="text"
                    value={newOperatorProfile.FortressURL}
                    onChange={handleNewOpChange}
                    className="w-full border-2 border-gray-300 p-3 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-colors"
                  />
                  {errors.FortressURL && <p className="text-red-500 text-sm mt-2">{errors.FortressURL}</p>}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{t('tools.operators.operatorEmail')}</label>
                  <input
                    id="OperatorEmail"
                    type="email"
                    value={newOperatorProfile.OperatorEmail}
                    onChange={handleNewOpChange}
                    className="w-full border-2 border-gray-300 p-3 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-colors"
                  />
                  {errors.OperatorEmail && <p className="text-red-500 text-sm mt-2">{errors.OperatorEmail}</p>}
                </div>
                <div className="flex items-center gap-3">
                  <input
                    type="checkbox"
                    id="MasterOperator"
                    checked={newOperatorProfile.MasterOperator}
                    onChange={handleNewOpChange}
                    className="h-5 w-5 text-[#35b888] rounded focus:ring-[#35b888]"
                  />
                  <label htmlFor="MasterOperator" className="text-sm font-medium text-gray-700">
                    {t('tools.operators.masterOperator')}
                  </label>
                </div>
                <div className="flex justify-end gap-3">
                  <button
                    type="button"
                    onClick={() => setnewOpClicked(false)}
                    className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-6 py-3 rounded-lg font-medium transition-colors"
                  >
                    {t('tools.common.cancel')}
                  </button>
                  <button
                    type="submit"
                    className="bg-[#35b888] hover:bg-[#2da075] text-white px-6 py-3 rounded-lg font-medium transition-colors"
                  >
                    {t('tools.operators.createOperator')}
                  </button>
                </div>
              </form>
            </div>
          )}

          {/* Confirmation Modal */}
          {showConfirmationModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white rounded-2xl shadow-2xl w-11/12 max-w-md overflow-hidden">
                <div className="p-6">
                  <h3 className="text-lg font-semibold text-gray-800 mb-3">{t('tools.operators.confirmStatusTitle')}</h3>
                  <p className="text-gray-600 mb-6">
                    {currentOperatorStatus
                      ? t('tools.operators.confirmEnable', { name: currentOperatorName })
                      : t('tools.operators.confirmDisable', { name: currentOperatorName })}
                  </p>
                  <div className="flex justify-end gap-3">
                    <button
                      onClick={() => {
                        setShowConfirmationModal(false);
                        setSwitchStates((prev) => ({
                          ...prev,
                          [currentOperatorId!]: !currentOperatorStatus,
                        }));
                      }}
                      className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-6 py-3 rounded-lg font-medium transition-colors"
                    >
                      {t('tools.common.cancel')}
                    </button>
                    <button
                      onClick={() => {
                        toggleOperatorStatus(currentOperatorId!, currentOperatorStatus, currentOperatorName);
                        setShowConfirmationModal(false);
                      }}
                      className="bg-[#35b888] hover:bg-[#2da075] text-white px-6 py-3 rounded-lg font-medium transition-colors"
                    >
                      {t('tools.common.confirm')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )}

    {/* Agent Tab */}
    {selectedMenu === 'Agent' && (
      <div className="card bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="p-4 md:p-6">
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
              <div className="p-2 bg-indigo-50 rounded-lg">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="text-indigo-600">
                  <path d="M12 15V17M12 21V22M12 3V5M3 12H5M19 12H21M7.75732 7.75736L6.34314 6.34314M16.2426 7.75736L17.6569 6.34314M7.75732 16.2426L6.34314 17.6569M16.2426 16.2426L17.6569 17.6569" 
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              {t('tools.agent.heading')}
            </h3>
            <p className="text-gray-600 mb-6">{t('tools.agent.subtitle')}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Specific Router Model Card */}
            <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2 bg-blue-50 rounded-lg">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="text-blue-600">
                    <path d="M8 17L12 13L16 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 22V12M12 2V4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <path d="M12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12Z" 
                      stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </div>
                <h4 className="font-semibold text-gray-800">{t('tools.agent.modelTitle')}</h4>
              </div>
              <p className="text-sm text-gray-600 mb-5">{t('tools.agent.modelDesc')}</p>
              
              <Form.Select
                aria-label={t('tools.agent.selectAria')}
                onChange={(event) => {
                  const selectedModel = event.target.value;
                  const selectedVendor = vendors.find((item) => item.model === selectedModel)?.vendor;
                  handleAgentModelList({ vendor: selectedVendor, model: selectedModel });
                }}
                className="mb-5 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
              >
                <option value={''}>{t('tools.agent.selectModel')}</option>
                {vendors.map((item) => (
                  <option key={item.model} value={item.model}>
                    {item.vendor} - {item.model}
                  </option>
                ))}
              </Form.Select>

              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setAgentType('model');
                    setStartBootloader(true);
                    handleStartBootloader();
                  }}
                  type="button"
                  className="bd-btn primary flex-1"
                >
                  <Play size={15} strokeWidth={2.2} />
                  {t('tools.agent.start')}
                </button>
                <button
                  onClick={() => {
                    setAgentType('model');
                    setStartBootloader(false);
                    handleStopBootloader();
                  }}
                  type="button"
                  className="bd-btn danger-soft flex-1"
                >
                  <Square size={13} strokeWidth={2.4} />
                  {t('tools.agent.stop')}
                </button>
              </div>
            </div>

            {/* Specific CPE Card */}
            <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2 bg-purple-50 rounded-lg">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="text-purple-600">
                    <path d="M12 18H12.01M8 4H16C17.1046 4 18 4.89543 18 6V18C18 19.1046 17.1046 20 16 20H8C6.89543 20 6 19.1046 6 18V6C6 4.89543 6.89543 4 8 4Z" 
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </div>
                <h4 className="font-semibold text-gray-800">{t('tools.agent.cpeTitle')}</h4>
              </div>
              <p className="text-sm text-gray-600 mb-5">{t('tools.agent.cpeDesc')}</p>
              
              <input
                className="w-full border-2 border-gray-300 p-3 rounded-lg mb-5 focus:outline-none focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-colors"
                placeholder={t('tools.agent.cpePlaceholder')}
                onChange={(event) => handleAgentCpeInput(event)}
              />

              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setAgentType('cpe');
                    setStartBootloader(true);
                    handleStartBootloader();
                  }}
                  type="button"
                  className="bd-btn primary flex-1"
                >
                  <Play size={15} strokeWidth={2.2} />
                  {t('tools.agent.start')}
                </button>
                <button
                  onClick={() => {
                    setAgentType('cpe');
                    setStartBootloader(false);
                    handleStopBootloader();
                  }}
                  type="button"
                  className="bd-btn danger-soft flex-1"
                >
                  <Square size={13} strokeWidth={2.4} />
                  {t('tools.agent.stop')}
                </button>
              </div>
            </div>

            {/* All Agents Card */}
            <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2 bg-orange-50 rounded-lg">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="text-orange-600">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h4 className="font-semibold text-gray-800">{t('tools.agent.allTitle')}</h4>
              </div>
              <p className="text-sm text-gray-600 mb-5">{t('tools.agent.allDesc')}</p>
              
              <input
                className="w-full border-2 border-gray-300 p-3 rounded-lg mb-5 focus:outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-colors"
                placeholder={t('tools.agent.allPlaceholder')}
                value={agentAllText}
                onChange={(event) => handleAgentAll(event)}
              />

              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setAgentType('all');
                    setStartBootloader(true);
                    handleStartBootloader();
                  }}
                  type="button"
                  className="bd-btn primary flex-1"
                >
                  <Play size={15} strokeWidth={2.2} />
                  {t('tools.agent.startAll')}
                </button>
                <button
                  onClick={() => {
                    setAgentType('all');
                    setStartBootloader(false);
                    handleStopBootloader();
                  }}
                  type="button"
                  className="bd-btn danger-soft flex-1"
                >
                  <Square size={13} strokeWidth={2.4} />
                  {t('tools.agent.stopAll')}
                </button>
              </div>
            </div>
          </div>

          {/* Agent Confirmation Modal */}
          {showAgentConfirmation && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white rounded-2xl shadow-2xl w-11/12 max-w-md overflow-hidden">
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="p-2 bg-yellow-50 rounded-lg">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="text-yellow-600">
                        <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                          stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-800">{confirmationTitle}</h3>
                  </div>
                  <p className="text-gray-600 mb-6">{confirmationMessage}</p>
                  <div className="flex justify-end gap-3">
                    <button
                      onClick={() => setShowAgentConfirmation(false)}
                      className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-6 py-3 rounded-lg font-medium transition-colors"
                    >
                      {t('tools.common.cancel')}
                    </button>
                    <button
                      onClick={() => {
                        setShowAgentConfirmation(false);
                        handleBootloaderConfirmation();
                      }}
                      className="bg-[#35b888] hover:bg-[#2da075] text-white px-6 py-3 rounded-lg font-medium transition-colors"
                    >
                      {t('tools.common.confirm')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )}
  </div>
</div>
    </section>
  );
};

export default function CustomNextIcon() {
  return (
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.943787" y="0.5" width="31" height="31" rx="7.5" stroke="#BBCEDB" />
      <path
        d="M14.4438 20L18.1183 16.7071C18.5523 16.3182 18.5523 15.6818 18.1183 15.2929L14.4438 12"
        stroke="#BBCEDB"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const CustomPreviousIcon = () => (
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="31.9438" y="31.5" width="31" height="31" rx="7.5" transform="rotate(-180 31.9438 31.5)" stroke="#BBCEDB" />
    <path
      d="M18.4438 12L14.7693 15.2929C14.3353 15.6818 14.3353 16.3182 14.7693 16.7071L18.4438 20"
      stroke="#BBCEDB"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
